import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import theme from './theme';
import { AuthProvider } from './context/AuthContext';
import { CurrencyProvider } from './context/CurrencyContext';
import ErrorBoundary from './components/ErrorBoundary';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import ForceChangePassword from './pages/ForceChangePassword';
import TenantDashboard from './pages/tenant/TenantDashboard';
import StaffDashboard from './pages/staff/StaffDashboard';
import AdminPanel from './pages/admin/AdminPanel';

function App() {
  return (
    <ErrorBoundary>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        {/* Inside AuthProvider: the currency is a company setting and reading it needs a
            session, so it waits for one rather than firing a 401 on the login page. */}
        <CurrencyProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/change-password" element={<ForceChangePassword />} />
            <Route
              path="/tenant/*"
              element={
                <PrivateRoute allowedRoles={['tenant']}>
                  <TenantDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/staff/*"
              element={
                <PrivateRoute allowedRoles={['staff', 'admin']}>
                  <StaffDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/*"
              element={
                <PrivateRoute allowedRoles={['admin']}>
                  <AdminPanel />
                </PrivateRoute>
              }
            />
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </Router>
        <ToastContainer position="top-right" autoClose={3000} />
        </CurrencyProvider>
      </AuthProvider>
    </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;

